/**
 * Scroll Animations — IntersectionObserver for .block--animated elements
 *
 * Adds .is-visible to .anim-fade elements when they enter the viewport.
 * Only runs on blocks with the .block--animated class (opt-in).
 * Respects prefers-reduced-motion via CSS (no JS check needed).
 */

export function initScrollAnimations() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  // Observe all anim-fade elements inside animated blocks
  const animatedBlocks = document.querySelectorAll('.block--animated');
  animatedBlocks.forEach((block) => {
    block.querySelectorAll('.anim-fade').forEach((el) => {
      observer.observe(el);
    });
  });
}
